import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import mixpanel, { initMixpanel } from "../../util/utilfunctions/mixpanel";

function MixpanelTracker() {
  const location = useLocation();

  const useMixPanel = useSelector(
    (state) => state.config.baseConfig?.useMixPanel
  );

  useEffect(() => {
    console.log("useMixPanel=====", useMixPanel);

    initMixpanel(useMixPanel === "1");
  }, [useMixPanel]);

  useEffect(() => {
    mixpanel.track_pageview({
      page: location.pathname,
      url: window.location.href,
    });
  }, [location]);

  return null;
}

export default MixpanelTracker;